/**
 * Simple Drag Scroll Web Component for Shopify
 * Usage: <drag-scroll>Your content here</drag-scroll>
 */

(function() {
    'use strict';

    class DragScroll extends HTMLElement {
        connectedCallback() {
            this.initDragScroll();
        }

        initDragScroll() {
            // Don't initialize twice
            if (this.hasAttribute('data-drag-initialized')) {
                return;
            }

            let isDown = false;
            let startX;
            let startY;
            let scrollLeft;
            let scrollTop;
            let hasMoved = false;
            let startTime = 0;

            // Set up the element styles
            this.style.cursor = 'grab';
            this.style.overflow = 'auto';
            this.style.userSelect = 'none';
            // this.style.display = 'block';

            // Helper function to check if element is interactive
            const isInteractiveElement = (element) => {
                const interactiveTags = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA', 'LABEL'];
                const interactiveRoles = ['button', 'link', 'menuitem', 'tab'];
                
                if (interactiveTags.includes(element.tagName)) {
                    return true;
                }
                
                if (element.getAttribute('role') && interactiveRoles.includes(element.getAttribute('role'))) {
                    return true;
                }
                
                if (element.getAttribute('onclick') || element.getAttribute('data-action')) {
                    return true;
                }
                
                if (element.style.cursor === 'pointer' || getComputedStyle(element).cursor === 'pointer') {
                    return true;
                }
                
                return false;
            };

            // Handle mouse down
            this.addEventListener('mousedown', (e) => {
                // Check if nochilddrag is set and we're clicking on a child element
                if (this.hasAttribute('nochilddrag') && e.target !== this) {
                    return;
                }

                // Don't start drag if clicking on interactive elements
                if (isInteractiveElement(e.target)) {
                    return;
                }

                isDown = true;
                hasMoved = false;
                startTime = Date.now();
                this.style.cursor = 'grabbing';
                startX = e.pageX - this.offsetLeft;
                startY = e.pageY - this.offsetTop;
                scrollLeft = this.scrollLeft;
                scrollTop = this.scrollTop;
                
                // Don't prevent default immediately - let links work if it's just a click
            });

            // Handle mouse leave
            this.addEventListener('mouseleave', () => {
                isDown = false;
                this.style.cursor = 'grab';
            });

            // Handle mouse up
            this.addEventListener('mouseup', (e) => {
                if (isDown && !hasMoved) {
                    // If we didn't move much, it was probably a click - let it through
                    const clickTime = Date.now() - startTime;
                    if (clickTime < 200) { // Less than 200ms is likely a click
                        // Find the original target and trigger click if it's interactive
                        if (isInteractiveElement(e.target)) {
                            e.target.click();
                        }
                    }
                }
                
                isDown = false;
                this.style.cursor = 'grab';
            });

            // Handle mouse move
            this.addEventListener('mousemove', (e) => {
                if (!isDown) return;

                const x = e.pageX - this.offsetLeft;
                const y = e.pageY - this.offsetTop;
                const walkX = Math.abs(x - startX);
                const walkY = Math.abs(y - startY);

                // Only start dragging if we've moved more than 5px
                if (walkX > 5 || walkY > 5) {
                    hasMoved = true;
                    e.preventDefault();

                    const scrollWalkX = (x - startX) * 2; // Scroll speed multiplier
                    const scrollWalkY = (y - startY) * 2;

                    this.scrollLeft = scrollLeft - scrollWalkX;
                    this.scrollTop = scrollTop - scrollWalkY;
                }
            });

            // Handle clicks on interactive elements
            this.addEventListener('click', (e) => {
                // If we just finished dragging, prevent the click
                if (hasMoved) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }, true); // Use capture phase

            // Mark as initialized
            this.setAttribute('data-drag-initialized', 'true');
        }

        // Method to reinitialize if content changes
        reinit() {
            this.removeAttribute('data-drag-initialized');
            this.initDragScroll();
        }
    }

    // Register the custom element
    if (!customElements.get('drag-scroll')) {
        customElements.define('drag-scroll', DragScroll);
    }

    // Make it globally available
    window.DragScroll = DragScroll;

})();